module.exports = __webpack_public_path__ + "static/img/til124.f1384e8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/til124.png
// module id = uu2t
// module chunks = 1